﻿(function ($) {
	var defaultOptions = {
		errorClass: 'invalid',
		validClass: 'valid',
		errorElement: 'span',
		onkeyup: false,
		onfocusout: function(element) { $(element).valid(); },
		highlight: function(element, errorClass, validClass) {
			$(element).closest(".input")
				.parent()
				.addClass(defaultOptions.errorClass)
				.removeClass(validClass);
		},
		unhighlight: function(element, errorClass, validClass) {
			$(element).closest(".input")
				.parent()
				.removeClass(defaultOptions.errorClass)
				.addClass(validClass);

		}
	};

	$.validator.setDefaults(defaultOptions);

	$.validator.unobtrusive.options = {
		errorClass: 'alert invalid',
		validClass: defaultOptions.validClass,
		errorElement: 'label'
	};


	// NB: overide some methods to support dutch validation.

	var parseNlNumber = function (value) {
		if (!value) return NaN;
		return parseFloat(value.replace(',', '.'));
	};

	var originalMethods = {		
		min: $.validator.methods.min,
		max: $.validator.methods.max,
		range: $.validator.methods.range,
	};

	$.validator.methods.number = function (value, element) {		
		var val = parseNlNumber(value);
		return this.optional(element) || ($.isNumeric(val));
	};

	$.validator.methods.min = function (value, element, param) {
		var val = parseNlNumber(value);
		return originalMethods.min.call(this, val, element, param);
	};

	$.validator.methods.max = function (value, element, param) {
		var val = parseNlNumber(value);
		return originalMethods.max.call(this, val, element, param);
	};

	$.validator.methods.range = function (value, element, param) {
		var val = parseNlNumber(value);
		return originalMethods.range.call(this, val, element, param);
	};

	// Custom override for a less strict e-mail validation
	jQuery.validator.addMethod("email", function (value, element, param) {
		return this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
	}, jQuery.validator.messages.email);

	
})(jQuery);
